var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('Menu',{attrs:{"color":(_vm.scrolled)? 'scrolledClass':'black'}}),_c('services-hero',{attrs:{"heroImage":_vm.heroImage,"heroText":_vm.heroText}}),_c(_vm.dynamicServicesContent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }